/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'string',
        enum: [
        'ACID_WASH',
        'ANTI_ACIDIC_COATING',
        'ANTI_BACTERIAL_ANTI_MICR',
        'BEAD_MANIPULATION',
        'BEADING',
        'BLAKE_WELTING',
        'BRAIDING',
        'BROAD_LOOM',
        'BRUSHING',
        'BURNOUT_PROCESSING',
        'CASTING',
        'CEMENTED',
        'CHAMELEON_FINISH',
        'CIRCULAR_KNIT',
        'CIRE_FINISH',
        'DEBOSS',
        'DECAL_PRINTING',
        'DENIM_WASH',
        'DIGITAL_PRINTING',
        'DIP_DYEING',
        'DISCHARGE_PRINTING',
        'DOWN_PROCESSING',
        'DYCOO',
        'EASY_CARE_WASH',
        'ELECTROPLATING',
        'EMBOSS',
        'ENAMEL_SPRAYED_PAINT',
        'ENAMELING',
        'ENGRAVING',
        'ETCHING',
        'FABRIC_BONDING',
        'FLAT_SCREEN_PRINTING',
        'FLOCKING',
        'FOIL_PRINTING',
        'GARMENT_DYEING',
        'GLAZING',
        'GOODYEAR_WELTING',
        'HAND_EMBROIDERY',
        'HAND_KNIT',
        'HAND_LINKING',
        'HAND_PRINTING',
        'HAND_QUILTING',
        'HEI_Q_FINISH',
        'HOLOGRAM',
        'INJECTION_MOULDING',
        'INSULATION',
        'JACQUARD_INTARSIA_KNIT',
        'LASER_CUT',
        'LEATHER_EMBOSSING',
        'LEATHER_PERF',
        'LEATHER_PRINTING',
        'MACHINE_SEWN_CONSTRUCTION',
        'MACHINE_COMPUTER_EMBROIDE',
        'MACHINE_COMPUTER_QUILTING',
        'METAL_WORKING',
        'MOCCASIN_CONSTRUCTION',
        'NEEDLE_LOOM',
        'NOVELTY_CABLE_KNIT',
        'OIL_REPELLENT_FINISH',
        'PEACHED_FINISH',
        'PEEL_STICK',
        'PIECE_DYE',
        'PIGMENT_DYE',
        'PIGMENT_PRINTING',
        'PLATING',
        'POSTCURE_FINISH',
        'PRECURE_FINISH',
        'PU_LAMINATION',
        'PUREPRESS_FINISH',
        'QUICK_DRY_FINISH',
        'REACTIVE_DYE',
        'REACTIVE_PRINTING',
        'ROTARY_PRINTING',
        'RUBBERIZED',
        'SANDBLASTING',
        'SHUTTLE_LOOM',
        'SILICON_MOULDED',
        'SILICON_PRINT',
        'SILICONE_WASH',
        'SIMPLE_KNIT',
        'SLIP_RESISTANT',
        'STAMPING',
        'STONE_CUTTING',
        'STONE_WASH',
        'SUBLIMATION_PRINTING',
        'TANNING_CRUST',
        'TANNING_RAW_HIDE',
        'TANNING_WET_BLUE',
        'TEFLON_FINISH',
        'TIE_DYEING',
        'TINTING',
        'TPU_PRINT',
        'UV_PROTECTION',
        'VULCANIZING',
        'WATER_REPELLENT_FINI',
        'WATERPROOFING',
        'WICKING_FINISH',
        'WOVEN_LEATHER',
        'WRINKLE_FREE_FINISH',
        'YARN_DYE',
        ],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    product_capabilities: valueSchema,
  },
}
